import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';
import { AuthService } from '../../auth/auth.service';
import { CountriesPage } from '../../countries/countries.page';
import { Preferences } from '@capacitor/preferences';

import { ThemeService } from '../../_core/services/theme.service';
import { ToastService } from '../../_core/services/toast.service';

@Component({
  standalone: false,
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  isDarkMode: any;
  logo: string;
  form: FormGroup;

  private readonly destroy$: Subject<void> = new Subject();
  isLoading: boolean;
  loginUrl: any;
  isLoggingIn: boolean;

  constructor(
    private themeService: ThemeService,
    private router: Router,
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private modalController: ModalController,
    private authService: AuthService,
    private toastService: ToastService
  ) { }

  ngOnInit() {
    this.isDarkMode = this.themeService.isDarkMode;
    this.logo = this.isDarkMode ? '/assets/img/logo-60-darkmode.png' : '/assets/img/logo-60.png';
    this.loginUrl = this.activatedRoute.snapshot.queryParamMap.get('returnTo') || '/';
    this.buildForm();
    // if (await this.modalCtrl.getTop()) this.isModal = true;

    this.themeService
      .subscribeThemeUpdate()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (isDarkMode) => {
          this.logo = isDarkMode ? '/assets/img/logo-60-darkmode.png' : '/assets/img/logo-60.png';
        }
      );
  }

  private buildForm() {
    this.form = this.fb.group({
        country_code: ['+1', [Validators.required, Validators.pattern('([+]{1})([0-9]{1,3})')]],
        phone: ['', [Validators.required, Validators.pattern('([1-9]{1})[0-9]{5,15}')]],
        password: ['', [Validators.required, Validators.minLength(6)]]
    });
}

  markFieldsDirty() {
    const controls = this.form.controls;
    for (const field in controls) {
      if (controls[field]) {
        controls[field].markAsDirty();
      }
    }
  }

  async login() {
      this.isLoggingIn = true;
      if (this.form.valid) {
          this.isLoading = true;
          (await this.authService.login(this.form.value))
            .pipe(finalize(() => this.isLoggingIn = false))
            .subscribe({
              next: async res => {
                this.authService.publishLoggedIn(true);
                this.router.navigateByUrl(this.loginUrl);
              }
            });
      } else {
        this.handleErrors();
      }
  }

  async handleErrors() {
    let errorMessage = '';
    if (this.form.get('country_code').invalid) {
        errorMessage = 'Country code must start with + followed by 1 to 3 digits';
    } else if (this.form.get('phone').invalid) {
        errorMessage = 'Phone must include area code and phone number. Digits only. If your first digit is 0 remove it.';
    } else {
        errorMessage = 'Password must have minimum 6 characters.';
    }
    this.toastService.presentDangerToast(errorMessage);
  }

  async getCountryCode() {
    const modal = await this.modalController.create({
        component: CountriesPage
    });

    await modal.present();
    const { data } = await modal.onDidDismiss();
    if (data) {
        this.form.get('country_code').setValue(data);
    }
  }

  navigate(route: string) {
    this.router.navigate([route])
  }



}
